<template>
  <div class="complete">
    <h1 class="h1 title">{{$t('contact.complete_title')}}</h1>
    <div class="lead white-space-pre-wrap">{{ $t('contact.complete_lead') }}</div>
    <div class="btn-wrapper">
      <router-link class="btn btn-red position-relative" :to="{'name':'home.index'}">{{$t('btn.back_complete')}}<span class="arrows arrows-first arrows-right border-white ml-7"></span></router-link>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { META_CONTACT } from '../../mixins/metadata.js'

  export default {
    mixins: [META_CONTACT],
    name: 'ContactSuccess',

    computed: {
      ...mapGetters('layout', ['layoutHeader']),
      topRoute() {
        switch (this.layoutHeader) {
          case 'client':
            return 'client.index'
          case 'user':
            return 'user.index'
          default:
            return 'index.index'
        }
      }
    }
  }
</script>
